export default "__VITE_ASSET__DkyUY8Th__"